<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'agro-tiporecomendacao') {
            next({ name: 'agro-tiporecomendacao-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'agro-tiporecomendacao') {
            this.$router.push({ name: 'agro-tiporecomendacao-list' });
        }
    },
};
</script>
